import angular, {
  IController,
  IHttpPromiseCallbackArg,
  IRootScopeService,
  IScope,
  IWindowService,
  ITimeoutService
} from 'angular';
import RunnerFlowService from './runner.flow.service';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { SharedAngular } from '@Client/@types/sharedAngular';
import { Guid } from '@Shared.Angular/@types/guid';
import IFormattedFlow from '@Client/interfaces/IFormattedFlow';
import CommentTargetType from '@Shared.Angular/@types/core/contracts/constants/commentTargetType';
import { CommentSource } from '@Shared.Angular/interfaces/comment.interface';
import DynamicActorTypes from '@Shared.Angular/@types/core/contracts/queryModel/node/dynamicActorTypes';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import ActivityTaskType from '@Shared.Angular/@types/core/contracts/queryModel/workflow/steps/activityTaskType';

export default class RunnerFlowController implements IController {
  static $inject = [
    '$state',
    '$scope',
    '$rootScope',
    '$window',
    '$stateParams',
    '$location',
    'lodashService',
    'goService',
    'flowListManager',
    'pubsubService',
    'sessionService',
    'flowsUtilityService',
    'flowinglyDiagramService',
    'commentApiService',
    'flow',
    'notificationService',
    'APP_CONFIG',
    'flowinglyConstants',
    'runnerFlowService',
    '$q',
    'flowApiService',
    'flowModelApiService',
    'guidService',
    'dialogService',
    'appInsightsService',
    'permissionsService',
    '$timeout'
  ];

  constructor(
    private $state: IStateService,
    private $scope: IScope,
    private $rootScope: IRootScopeService,
    private $window: IWindowService,
    private $stateParams: IStateParamsService,
    $location: angular.ILocationService,
    private lodashService: Lodash,
    private goService: GoJS,
    private flowListManager: FlowListManager,
    private pubsubService: SharedAngular.PubSubService,
    private sessionService: SharedAngular.SessionService,
    private flowsUtilityService: SharedAngular.FlowsUtilityService,
    private flowinglyDiagramService: SharedAngular.FlowinglyDiagramService,
    private commentApiService: SharedAngular.CommentApiService,
    private _flow_: IFormattedFlow,
    private notificationService: SharedAngular.NotificationService,
    private APP_CONFIG: SharedAngular.APP_CONFIG,
    private flowinglyConstants: SharedAngular.FlowinglyConstants,
    private runnerFlowService: RunnerFlowService,
    private $q: angular.IQService,
    private flowApiService: FlowApiService,
    private flowModelApiService: SharedAngular.FlowModelApiService,
    private guidService: SharedAngular.GuidService,
    private dialogService: SharedAngular.DialogService,
    private appInsightsService: SharedAngular.AppInsightsService,
    private permissionsService: SharedAngular.PermissionsService,
    private $timeout: ITimeoutService
  ) {
    this.commentTargetTypeFlow = CommentTargetType.FLOW;
    this.commentSourceRunner = CommentSource.Runner;
    this.isTestFlow = $location.search().isTestFlow === 'true';
  }
  public flow: IFormattedFlow;
  public noPermisson = false;
  public startingFlowModel = false;
  public showFlow = true;
  public unhandledException = false;
  public tabStrip: any;
  public flowComments: any;
  public commentTargetTypeFlow: CommentTargetType;
  public showSupportButton: boolean;
  public progress = 0;
  public flowProcessWidth = 100;
  public searchable = false;
  public commentSourceRunner: CommentSource;
  public selectedStepId?: Guid;
  public selectedStepIsWaitingForYou = false;
  public selectedStepIsCompleted = false;

  public tabOptions = {
    activate: this.onTabActive
  };
  public tabOptionsMobile = {
    scrollable: false,
    activate: this.onTabActive
  };

  public canEdit: boolean;
  public showComments: boolean;

  public newFlowIsDynamicType: boolean;
  public newFlowParameters: any;
  public newFlowForm: angular.IFormController;
  public newFlowDynamicActorList: IDynamicActor[] = [];
  public isCurrentlyStartingFlow = false;
  public shouldForceShowErrors = false; // initially hidden until a submit attempt is done

  public description: string;
  public isSameUser = false;
  public enableTagging: boolean;
  public enableWorkflowStepAssistant: boolean;

  private subscriberId = 'runnerFlowController';
  public isTestFlow: boolean;
  public isRestartingTestFlow = false;
  public $onInit() {
    const {
      pubsubService,
      guidService,
      sessionService,
      $stateParams,
      flowModelApiService,
      runnerFlowService,
      flowinglyConstants,
      flowsUtilityService,
      lodashService,
      notificationService,
      _flow_
    } = this;
    pubsubService.subscribe(
      'SIGNALR_RUNNER_COMPLETE_STEP',
      this.onRunnerFlowStatusChange.bind(this),
      this.subscriberId
    );
    pubsubService.subscribe(
      'SIGNALR_RUNNER_REASSIGN_STEP',
      this.onRunnerFlowStatusChange.bind(this),
      this.subscriberId
    );
    pubsubService.subscribe(
      'SIGNALR_RUNNER_WITHDRAW_FLOW',
      this.onRunnerFlowWithdrawn.bind(this),
      this.subscriberId
    );
    pubsubService.subscribe(
      'NAVIGATE_BACK',
      this.onBackButtonClick.bind(this),
      this.subscriberId
    );
    pubsubService.subscribe(
      'SIGNALR_RUNNER_STEP_INTEGRATION_PROCESSING_UPDATED',
      this.onRunnerFlowStatusChange.bind(this),
      this.subscriberId
    );

    this.showSupportButton = this.shouldShowSupportButton(
      this.APP_CONFIG.hideSupportButton
    );
    this.registerKendoWidget();
    this.registerSplitter();

    this.enableTagging = this.APP_CONFIG.enableTagging;
    this.enableWorkflowStepAssistant =
      this.APP_CONFIG.enableWorkflowStepAssistant;

    if (
      this.$stateParams.flowRequestErrorStatus !== undefined &&
      !this._flow_
    ) {
      this.handleFlowLoadError();
    } else {
      this.flow = _flow_ as IFormattedFlow;
      this.flow.FilesCount = this.getFileCount(this.flow);
      runnerFlowService.hasStarted = this.flow.FlowId != guidService.empty();

      if (runnerFlowService.hasStarted == false) {
        const { flowModelId } = $stateParams;
        const loggedInUser = sessionService.getUser();

        flowModelApiService
          .getPublishedFlowModel(flowModelId)
          .then((flowModel) => {
            // these are needed for us to generate the flow model
            // on the flow model tab
            this.flow.FlowModelId = flowModelId;
            this.flow.Id = guidService.new();
            this.flow.FlowSchema = flowModel.flowSchema;
            this.flow.Name = flowModel.name;
            this.flow.TagIds = flowModel.tagIds;
            this.description = flowModel.description;
            this.searchable = flowModel.searchable;

            // logic copied from runner.flow.start.component from commit
            // that exists in commit d7f7cc0999d91b989ab62ba738225f17baac0622
            this.newFlowIsDynamicType = !!(
              flowModel.dynamicActorType &&
              flowModel.dynamicActorType ===
                DynamicActorTypes.SelectDynamicActors &&
              flowModel.selectedDynamicActors.length > 0
            );

            if (this.newFlowIsDynamicType) {
              this.newFlowDynamicActorList =
                flowModel.selectedDynamicActors.map((actor) => {
                  return {
                    displayName: actor.fullName,
                    actorId: actor.id
                  } as IDynamicActor;
                });
            }
          });

        this.newFlowParameters = {
          flowModelId: flowModelId,
          requesterId: loggedInUser.id,
          subject: '',
          ccActors: [],
          bulkActors: [
            {
              id: loggedInUser.id,
              displayName: loggedInUser.fullName,
              avatarUrl: null,
              searchEntityType: flowinglyConstants.searchEntityType.USER
            }
          ]
        };
      }

      //if we are viewing this flow from a report, there will be a flowId in the query string
      const stepParam = flowsUtilityService.getStateParamValue('step');
      if (stepParam) {
        const stepDetails = lodashService.find(this.flow.Steps, (step) => {
          return step.Id.toUpperCase() === stepParam.toUpperCase();
        });

        if (
          stepDetails.IsCompleted &&
          stepDetails.ActorAssignedId !== stepDetails.CompletedById
        ) {
          notificationService.showSuccessToast(
            `${stepDetails.Name} was completed by ${stepDetails.CompletedByName} on behalf of ${stepDetails.ActorAssignedName}`,
            10000
          );
        }
      }

      this.showComments =
        flowsUtilityService.getStateParamValue('showComments');
      this.showFlow =
        !(this.flow.FinalisedReason === 'Withdrawn') ||
        this.APP_CONFIG.enableCancelledFlowsView;
      this.canEdit =
        this.permissionsService.currentUserHasPermission(
          flowinglyConstants.permissions.FLOWMODEL_UPDATE
        ) || this.flow.IsFlowModelOwner;

      // unsubscribeAll when scope destroy
      this.$scope.$on('$destroy', () => {
        pubsubService.unsubscribeAll(this.subscriberId);
      });
    }
  }

  public onSupportButtonClick() {
    const { sessionService, $stateParams, $window } = this;
    const loggedInUser = sessionService.getUser();
    const flowId = $stateParams.flowId;

    this.flowApiService.getFlowSupportDetails(flowId).then((response) => {
      const supportDetails = JSON.parse(response);
      $window.location.href =
        `mailto:${this.APP_CONFIG.brandingSupportEmail}?subject=There was an error opening flow ` +
        supportDetails.flowIdentifier +
        '&body=Logged in User: ' +
        loggedInUser.email +
        '%0D' +
        'Logged in Users Manager: ' +
        supportDetails.userManager +
        '%0D' +
        'FlowId: ' +
        flowId +
        '%0D' +
        'Flow-ID: ' +
        supportDetails.flowIdentifier +
        '%0D' +
        'Current Step Name: ' +
        supportDetails.currentStepName +
        '%0D' +
        'Date/Time: ' +
        new Date();
    });
  }

  public onTabActive(e) {
    angular
      .element(e.item)
      .text()
      .replace(/(\(\d*\))/gm, '')
      .trim();
  }

  public onCommentsClick() {
    const { commentApiService } = this;

    if (!this.hasStarted()) {
      return;
    }

    commentApiService
      .getFlowComments(this.commentTargetTypeFlow, this.flow.FlowId)
      .then((data) => {
        this.flowComments = data;
        this.flow.CommentCount = this.flowComments.length;
        this.tabStrip.select(1);
      });
  }

  public shouldShowSupportButton(configHide) {
    return (
      !configHide ||
      this.permissionsService.currentUserHasPermission(
        this.flowinglyConstants.permissions.SUPPORT_ACCESS
      )
    );
  }

  public canStartFlowOnBehalf() {
    return this.permissionsService.currentUserHasPermission(
      this.flowinglyConstants.permissions.FLOW_STARTONBEHALF
    );
  }

  public showFlowModel(flow) {
    this.flowinglyDiagramService.generateProcessModel({
      flow: flow,
      applyAvatar: false,
      modelCustomArgs: {
        scrollMode: this.goService.Diagram.DocumentScroll
      }
    });
  }

  public onCommentAdded(flowId, count) {
    this.flow.CommentCount = count;
  }

  public getDesktopFlowTabClass(): string {
    const visibleTabCount =
      3 +
      (this.shouldShowWorkflowStepAssistant() ? 1 : 0) +
      (this.enableTagging ? 1 : 0);

    if (visibleTabCount === 3) {
      return 'l4';
    }

    if (visibleTabCount === 4) {
      return 'l3';
    }

    return 'flow-tab-width--5';
  }

  public shouldShowWorkflowStepAssistant(): boolean {
    return (
      this.enableWorkflowStepAssistant &&
      this.hasStarted() &&
      !!this.flow?.Steps &&
      !this.flow.IsFinalised &&
      this.flow.IsStepAssistEnabled
    );
  }

  public onSelectedStepChange(
    stepId: Guid,
    isWaitingForYou: boolean,
    isCompleted: boolean
  ): void {
    this.selectedStepId = stepId;
    this.selectedStepIsWaitingForYou = isWaitingForYou;
    this.selectedStepIsCompleted = isCompleted;
  }
  private flushKendoEditorValues() {
    angular.element('textarea[kendo-editor]').each((_, el) => {
      const $el = angular.element(el);
      const editor = $el.data('kendoEditor');
      if (!editor) {
        return;
      }
      const scope = $el.scope() as IScope;
      // Only blur if the editor is focused, to avoid stealing focus during integration processing updates.
      if (editor.body && editor.body.ownerDocument.hasFocus()) {
        editor.body.blur();
        this.$window.focus();
      }
      if (scope?.form?.data && scope?.field?.schema?.name) {
        scope.form.data[scope.field.schema.name] = editor.value();
      }
    });
  }

  public onRunnerFlowStatusChange(event, message) {
    const data = JSON.parse(message);

    const flowId = data.flowId || data.flow.flowId;
    if (flowId !== this.flow.FlowId) {
      return;
    }

    this.flushKendoEditorValues();

    this.runnerFlowService
      .getFlowById(flowId)
      .then((formattedFlow) => {
        if (!formattedFlow) {
          return;
        }
        this.flow = formattedFlow;
        this.progress = this.flow.PercentageComplete;
        this.flow.FilesCount = this.getFileCount(this.flow);

        //FLOW-4947 - re-render the flow model if the current tab is the Flow Model tab
        if ($('li[aria-controls=tabstrip-3]').hasClass('k-state-active')) {
          this.showFlowModel(this.flow);
        }
      })
      .catch((response: IHttpPromiseCallbackArg<null>) => {
        this.$stateParams.flowRequestErrorStatus = response.status;
        this.handleFlowLoadError();
        this._flow_ = null;
      });
  }

  private handleFlowLoadError() {
    this.showFlow = false;
    const forbiddenStatus = 403;
    if (this.$stateParams.flowRequestErrorStatus === forbiddenStatus) {
      this.noPermisson = true;
      this.startingFlowModel = this.$stateParams.flowModelId != undefined;
    } else {
      this.unhandledException = true;
    }
  }

  public onRunnerFlowWithdrawn() {
    this.onBackButtonClick();
  }

  public onBackButtonClick() {
    const { $rootScope, $state, $window, $stateParams } = this;
    let route = $rootScope.previousRoute || '';
    route = route.indexOf('//') !== -1 ? route.replace('//', '/') : route;
    switch (route.split('?')[0]) {
      case '/flows/{flowId}':
      case '/flowsactive/{categoryId}':
      case '/flowsactive/':
        $state.go(STATE_MAPPINGS.flowsactive, {
          backFromState: $state.current.name
        });
        break;
      case '/flowstodo':
        $state.go(STATE_MAPPINGS.flowstodo, {
          backFromState: $state.current.name
        });
        break;
      case '/flowsin':
        $state.go(STATE_MAPPINGS.flowsin);
        break;
      case '/processmaps':
        $state.go(STATE_MAPPINGS.libraryprocessmaps);
        break;
      case '/drafts':
        $state.go(STATE_MAPPINGS.librarydrafts);
        break;
      case '/workflows':
        $state.go(STATE_MAPPINGS.libraryworkflows);
        break;
      case '/report/{flowModelId}':
        $window.history.go(-1);
        break;
      case '/search?:term':
        if ($stateParams.searchJump)
          $window.history.go(-2); // go back to the page prior to the search
        else
          $state.go(STATE_MAPPINGS.search, {
            term: $rootScope.previousSearchTerm
          });
        break;
      default:
        $state.go(STATE_MAPPINGS.flowsin);
    }
  }

  public closeTestFlow = (): void => {
    this.$window.close();
  };

  public restartTestFlow = (): void => {
    this.isRestartingTestFlow = true;
    const hasPublicForm = this.flow.Steps.some(
      (step) => step.StepType === ActivityTaskType.PUBLIC_FORM
    );
    if (hasPublicForm) {
      this.$window.open(
        `/form/${this.flow.FlowModelId}?isTestFlow=true`,
        '_blank'
      );
      this.$window.close();
      return;
    }

    this.flowModelApiService
      .startTestFlow(this.flow.FlowModelId, this.flow.FlowModelSchemaId)
      .then((newFlowId) => {
        this.$window.open(`/flows/${newFlowId}?isTestFlow=true`, '_blank');
        this.$window.close();
      })
      .catch((error) => {
        this.isRestartingTestFlow = false;
        console.error(error);
      });
  };

  public shouldShowErrors() {
    return this.shouldForceShowErrors || this.newFlowForm.$dirty;
  }

  public tryAndStartFlow(): angular.IPromise<void> {
    this.shouldForceShowErrors = true; // initially hidden until a submit attempt is done

    if (this.hasSubjectError()) {
      return this.$q.reject();
    } else if (this.newFlowIsDynamicType === true) {
      /*
       * Yes this is a very convulated way to get the name of the step but so far this is
       * the only way we can get the step name with the variables we have in this controller
       */
      let firstStep = null;
      try {
        const schema = JSON.parse(this.flow.FlowSchema as string);
        const startNode = schema.nodeDataArray.find(
          ({ item }) => item == 'start'
        );
        const startNodeLink = schema.linkDataArray.find(
          ({ from }) => from == startNode.key
        );
        firstStep = schema.nodeDataArray.find(
          ({ key }) => startNodeLink.to == key
        );
      } catch (err) {
        console.warn(
          'There was a problem trying to determine the name of the first step. Falling back to generic message...'
        );
        console.warn(err.stack);
      }

      if (this.newFlowDynamicActorList.length == 1) {
        const loggedInUser = this.sessionService.getUser();
        for (let i = 0; i < this.newFlowDynamicActorList.length; i++) {
          if (loggedInUser.id == this.newFlowDynamicActorList[i].actorId) {
            this.isSameUser = true;
          }
        }
        if (this.isSameUser == true) {
          return this.startFlow(loggedInUser.id);
        } else {
          return this.dynamicActorsDialog(firstStep).then(
            (assignedDynamicActors) => {
              if (
                !assignedDynamicActors ||
                assignedDynamicActors.length === 0
              ) {
                return null;
              } else {
                return this.startFlow(
                  assignedDynamicActors.pop().assignedDynamicActorId
                );
              }
            }
          );
        }
      } else {
        return this.dynamicActorsDialog(firstStep).then(
          (assignedDynamicActors) => {
            if (!assignedDynamicActors || assignedDynamicActors.length === 0) {
              return null;
            } else {
              return this.startFlow(
                assignedDynamicActors.pop().assignedDynamicActorId
              );
            }
          }
        );
      }
    } else {
      return this.startFlow();
    }
  }

  private dynamicActorsDialog(firstStep) {
    return this.dialogService
      .showDialog({
        template:
          'Client/runner.flow/runner.flow.form/runner.flow.dynamic-actor.dialog.tmpl.html',
        controller: 'dynamicActorDialogController',
        appendClassName: 'ngdialog-theme-plain w-500',
        data: {
          /* this is just a stub to make this controller
           * work with data it is not used for
           *
           * @TODO genericify this display dialogue
           */
          dynamicActorsForSteps: [
            {
              dynamicActors: this.newFlowDynamicActorList,
              nodeId: null,
              searchable: this.searchable,
              stepName: firstStep.text,
              uniqueId: this.guidService.new() // dummy id
            }
          ],
          modelerNodeId: firstStep.id
        }
      })
      .then((assignedDynamicActors) => {
        if (
          this.dialogService.isCloseModalWithCancelAction(assignedDynamicActors)
        ) {
          //user closed modal by clicking on overlay (or cancel or press Esc key)
          return null;
        }
        return assignedDynamicActors;
      });
  }

  private registerKendoWidget() {
    this.$scope.$on('kendoWidgetCreated', (ev, widget) => {
      if (widget === this.tabStrip) {
        if (!this.showComments) {
          this.tabStrip.select(0);
        } else {
          this.onCommentsClick();
        }
      }
    });
  }

  private registerSplitter() {
    this.$timeout(() => {
      const leftPane = angular.element(document.querySelector('.pane-left'));
      const rightPane = angular.element(document.querySelector('.pane-right'));
      const splitter = angular.element(document.querySelector('.splitter'));
      if (leftPane && rightPane && splitter) {
        let isDragging = false;
        splitter.on('pointerdown', (e) => {
          isDragging = true;
          document.body.style.userSelect = 'none';
          splitter[0].setPointerCapture(e.pointerId);
          window.addEventListener('pointermove', onPointerMove);
          window.addEventListener('pointerup', onPointerUp);
        });

        const onPointerMove = (e) => {
          if (isDragging) {
            const container = angular.element(
              document.querySelector('.splitter-container')
            );
            const containerWidth = container[0].clientWidth;
            const containerOffsetLeft = container[0].offsetLeft;
            const maxPaneWidth = (containerWidth * 2) / 3;
            let leftPaneWidth = e.clientX - containerOffsetLeft;

            if (leftPaneWidth > maxPaneWidth) {
              leftPaneWidth = maxPaneWidth;
            } else if (leftPaneWidth < containerWidth - maxPaneWidth) {
              leftPaneWidth = containerWidth - maxPaneWidth;
            }

            leftPane.css('width', `${leftPaneWidth}px`);
            rightPane.css('width', `calc(100% - ${leftPaneWidth}px)`);
          }
        };

        const onPointerUp = (e) => {
          if (isDragging) {
            document.body.style.userSelect = '';
            isDragging = false;
            splitter[0].releasePointerCapture(e.pointerId);
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerup', onPointerUp);
          }
        };
      }
    });
  }

  private startFlow(assignedActorId?: any): angular.IPromise<void> {
    if (this.isCurrentlyStartingFlow) {
      return;
    }
    this.isCurrentlyStartingFlow = true;
    const {
      lodashService,
      runnerFlowService,
      $state,
      notificationService,
      $q,
      appInsightsService
    } = this;
    const transformFn = this._transformForStartFlow.bind(this);
    const { newFlowParameters } = this;
    const loggedInUser = this.sessionService.getUser();
    const bulkActors = newFlowParameters.bulkActors.map(transformFn);
    const ccActors = newFlowParameters.ccActors.map(transformFn);

    // Set the datetime the flow start was triggered by the user. This is to get the time taken to start a flow
    // after user selected start.
    appInsightsService.startEventTimer('flowStarted');
    if (bulkActors.length > 0) {
      appInsightsService.startEventTimer('flowStartedForBulkActors');
    }
    let promise;

    const shouldAppendNameToSubject = bulkActors.length > 1;
    /*
     * We process the user's request first so and update the rest of the bulk requests
     * after. This is so that the user won't have to wait for a super long time to start the flow.
     */
    const currUsersRequest = lodashService.remove(
      bulkActors,
      (u) => u.userId == loggedInUser.id
    );
    if (currUsersRequest.length) {
      promise = runnerFlowService
        .startFlow(
          newFlowParameters.flowModelId,
          newFlowParameters.subject,
          currUsersRequest,
          ccActors,
          assignedActorId,
          shouldAppendNameToSubject
        )
        .then(
          (response) => {
            let flowId = '';
            if (response?.length) {
              [flowId] = response;
              $state.go(
                STATE_MAPPINGS.flow,
                { flowId, flowModelId: undefined },
                { notify: true }
              );

              notificationService.showSuccessToast(`Flow started`);
            }
            appInsightsService.trackMetricIfTimerExist('flowStarted', {
              flowId,
              flowModelId: newFlowParameters.flowModelId
            });
          },
          (response) => {
            notificationService.showErrorToast(
              response.errorMessage ||
                `There was an error trying to start the flow.`
            );
            appInsightsService.trackMetricIfTimerExist('flowStarted', {
              flowId: '',
              flowModelId: newFlowParameters.flowModelId
            });
          }
        );
    }

    if (bulkActors.length > 0) {
      promise = $q.resolve(promise).then(() => {
        return runnerFlowService
          .startFlow(
            newFlowParameters.flowModelId,
            newFlowParameters.subject,
            bulkActors,
            ccActors,
            null,
            shouldAppendNameToSubject,
            currUsersRequest.length ? [loggedInUser.id] : null
          )
          .then(
            (response) => {
              if (response?.length) {
                const otherUserCount = response.length;
                notificationService.showSuccessToast(
                  `Successfully started for ${otherUserCount} other user${
                    otherUserCount > 1 ? 's' : ''
                  }.`
                );

                if (currUsersRequest.length == 0) {
                  // can't use transition because "/" is an abstract state
                  $state.go(STATE_MAPPINGS.flowsactive);
                }
              }
              appInsightsService.trackMetricIfTimerExist(
                'flowStartedForBulkActors',
                {
                  bulkActorsCount: bulkActors.length,
                  flowIds: response?.toString() ?? ''
                }
              );
            },
            (response) => {
              notificationService.showErrorToast(
                response.errorMessage ||
                  `There was an error trying to start the flow.`
              );
              appInsightsService.trackMetricIfTimerExist(
                'flowStartedForBulkActors',
                {
                  bulkActorsCount: bulkActors.length,
                  flowIds: ''
                }
              );
            }
          );
      });
    }

    promise = promise
      .catch((error) => {
        this.isCurrentlyStartingFlow = false;
        console.error(error);
      })
      .then(() => {
        this.isCurrentlyStartingFlow = false;
      });

    return promise;
  }

  hasSubjectError(): boolean {
    const subject = this.newFlowForm.subject;
    return subject.$pristine || subject.$invalid;
  }

  private _transformForStartFlow({ searchEntityType, id }) {
    const { flowinglyConstants } = this;
    const param = { userId: '', groupId: '' };
    switch (searchEntityType) {
      case flowinglyConstants.searchEntityType.USER:
        param.userId = id;
        break;
      case flowinglyConstants.searchEntityType.GROUP:
        param.groupId = id;
        break;
    }
    return param;
  }

  public hasStarted(): boolean {
    // introduced by at FLOW-4651, you can now open this page in 2 states.
    // It can be started (old flow of events) or not-started (things)
    // are configured on this page.
    return this.runnerFlowService.hasStarted;
  }

  /**
   * This code is copied from runner.flow.header\runner.flow.header.component
   */
  private getFileCount(flow: IFormattedFlow) {
    let count = 0;
    if (flow.Steps) {
      for (let i = 0; i < flow.Steps.length; i++) {
        const step = flow.Steps[i];
        for (let j = 0; j < step.Fields.length; j++) {
          const field = step.Fields[j];
          if ((field as any).HasFiles) {
            count++;
          } else if (field.Type === 'table') {
            if (field.TableHasRows) {
              const table = JSON.parse(field.Text);
              angular.forEach(table.rows, function (row) {
                angular.forEach(row.cells, function (cell) {
                  if (cell.type === 4) {
                    if (cell.value) {
                      count++;
                    }
                  }
                });
              });
            }
          }
        }
      }
      return count;
    }
  }
}

interface IDynamicActor {
  actorId: Guid;
  displayName: string;
}

angular
  .module('flowingly.runner.flow')
  .controller('runnerFlowController', RunnerFlowController);
